export default __webpack_public_path__ + "static/media/promo-issue-no-1_02.34a2ebe5.jpg";